import { toPlural } from 'helpers/HelperFunctions';
import { POPULAR_JOB_ROLES } from 'constants/popularJobLinks';

export const normalizeRoleKey = (value) =>
  (value || '').toString().toLowerCase().replace(/-/g, ' ').trim();

export const isRoleSelected = (selectedRoles, roleName, slug) => {
  if (!selectedRoles || selectedRoles.length === 0) return false;
  const keys = [
    normalizeRoleKey(roleName),
    normalizeRoleKey(slug),
    normalizeRoleKey(toPlural(roleName)),
  ].filter(Boolean);

  return selectedRoles.some((selected) =>
    keys.includes(normalizeRoleKey(selected))
  );
};

/** Set-equality of role selections (order-independent, normalized). */
export const rolesSelectionEqual = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  const keysB = new Set(b.map(normalizeRoleKey));
  return a.every((role) => keysB.has(normalizeRoleKey(role)));
};

/**
 * Resolve a selected role token to the display name/slug the filter column uses.
 */
export const resolveSelectedRole = (selected, suggestedRoles = []) => {
  const popular = POPULAR_JOB_ROLES.find((role) =>
    isRoleSelected([selected], role.name, role.slug)
  );
  if (popular) {
    return { name: popular.name, slug: popular.slug };
  }

  const suggested = (suggestedRoles || []).find((role) => {
    const name = role.name || role.label || role.value;
    const slug = role.slug_plural || role.slug || null;
    return isRoleSelected([selected], name, slug);
  });
  if (suggested) {
    return {
      name: suggested.name || suggested.label || suggested.value,
      slug: suggested.slug_plural || suggested.slug || null,
    };
  }

  return { name: selected, slug: null };
};
